import React, { FC, PropsWithChildren } from 'react'

export const LoginContainer: FC<PropsWithChildren> = ({ children }) => {
  return <div className="mx-auto max-w-[22rem]">{children}</div>
}
